import React, {Fragment} from "react";
import loading from "./loading.gif";
const Loading = () => (
  <Fragment>
    <img src={loading} alt="loading..." />
  </Fragment>
);
export default Loading;
